import { useMutation, UseMutationOptions } from "@tanstack/react-query";

import { ChangelogComment } from "./types";

import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";

export interface CreateCommentRequest {
  text: string;
  changelog_id: number;
  thread_id: number | null;
}

export interface CreateCommentResponse {
  success: boolean;
  comment: ChangelogComment;
}

interface UseCreateCommentVariables {
  workspaceId: number;
  data: CreateCommentRequest;
}

export const useCreateComment = (
  options?: UseMutationOptions<CreateCommentResponse, Error, UseCreateCommentVariables>,
) => {
  const userToken = useAuth()?.userToken ?? "";

  return useMutation<CreateCommentResponse, Error, UseCreateCommentVariables>({
    mutationFn: async ({ workspaceId, data }) => {
      const response = await fetch(ENDPOINTS.changelog_comments(workspaceId), {
        method: "POST",
        headers: jsonAuthHeaders(userToken),
        body: JSON.stringify(data),
      });

      return handleResponse(response);
    },
    ...options,
  });
};
